// extracted by mini-css-extract-plugin
module.exports = {"container":"_1knFzz4hhArhoOBqifAZB8","visible":"sD-2zCgMbLAA71QZplkVQ","cancelBtn":"_2eMU2jrF2dxRAvymNX7cK8","icon":"FUlzJAfI4fnvTAb0p-pY9","saveBtn":"_3iGON_-oU0o1DMcUNSGe_B"};